var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"Icon",class:_vm.iconClasses,attrs:{"alt":"","aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#Icon--' + _vm.symbol}})])}
var staticRenderFns = []

export { render, staticRenderFns }